import { Dispatch, SetStateAction, useCallback } from 'react'
import { StockUnionType } from 'types/stock'
import { StoreDefaultScheduleType } from 'types/storeDefault'

const useInitDefaultSchedulesByType = (
  getUpdateSchedulesFunction: (
    type: StockUnionType,
    setDailySchedules: Dispatch<SetStateAction<StoreDefaultScheduleType[]>>,
    setPreorderSchedules: Dispatch<SetStateAction<StoreDefaultScheduleType[]>>
  ) => Dispatch<SetStateAction<StoreDefaultScheduleType[]>> | undefined,
  setDailySchedules: Dispatch<SetStateAction<StoreDefaultScheduleType[]>>,
  setPreorderSchedules: Dispatch<SetStateAction<StoreDefaultScheduleType[]>>,
  setIsTypeDaily: Dispatch<SetStateAction<boolean>>,
  setIsTypePreorder: Dispatch<SetStateAction<boolean>>,
  setIsTypeShared: Dispatch<SetStateAction<boolean>>,
  setIsTypeDelivery: Dispatch<SetStateAction<boolean>>
): ((type: StockUnionType) => void) => {
  return useCallback(
    (type: StockUnionType) => {
      const update = getUpdateSchedulesFunction(type, setDailySchedules, setPreorderSchedules)
      if (!update) return
      update([])
      switch (type) {
        case 'daily':
          setIsTypeDaily(false)
          break
        case 'preorder':
          setIsTypePreorder(false)
          break
        case 'shared':
          setIsTypeShared(false)
          break
        default:
          break
      }
    },
    [
      getUpdateSchedulesFunction,
      setDailySchedules,
      setPreorderSchedules,
      setIsTypeDaily,
      setIsTypePreorder,
      setIsTypeShared,
      setIsTypeDelivery,
    ]
  )
}

export default useInitDefaultSchedulesByType
